<template>
  <div>
    <p class="text-left">{{ $t('videocall.thankYou.info') }}</p>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'VideoCallThankYou',
  mounted() {
    this.setDialogTitle(this.$t('videocall.thankYou.success'));
    this.setDialogLeftHeaderIcon('icons/confetti.svg');
    this.setDialogButtons([
      {
        events: {
          click: () => {
            this.$emit('close');
          }
        },
        text: this.$t('videocall.thankYou.close')
      }
    ]);
  },
  methods: {
    ...mapActions({
      setDialogTitle: 'staticForms/videoCall/thankYou/setDialogTitle',
      setDialogButtons: 'staticForms/videoCall/thankYou/setDialogButtons',
      setDialogLeftHeaderIcon: 'staticForms/videoCall/thankYou/setDialogLeftHeaderIcon'
    })
  }
};
</script>
<style scoped>

</style>
